export default __webpack_public_path__ + "static/media/lukhu_picks.50798238.png";